
// src/components/Navbar.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebase"; // Ajusta la ruta

export default function Navbar() {
    const navigate = useNavigate();

    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                navigate("/login");
            })
            .catch((err) => {
                console.error("Error al cerrar sesión", err);
            });
    };

    return (
        <div className="navbar bg-base-200 shadow-lg py-2">
            {/* Zona izquierda: Logo o Título */}
            <div className="flex-1">
                <Link to="/dashboard" className="btn btn-ghost normal-case">
                    <img src="/logo-farmacia.png" alt="Logo" className="h-10" />
                </Link>
            </div>

            {/* Zona derecha: Menú de navegación */}
            <div className="flex-none">
                <ul className="menu menu-horizontal p-0">
                    <li>
                        <Link to="/dashboard">Ventas</Link>
                    </li>
                    <li>
                        <Link to="/stock">Reposición</Link>
                    </li>
                    <li>
                        <Link to="/distribucion">Distribución</Link>
                    </li>
                    <li>
                        <Link to="/rotacion">Rotación</Link>
                    </li>
                    {/* <li>
                        <Link to="/abandoned-carts">Carros abandonados</Link>
                    </li> */}

                    <li>
                        <button onClick={handleLogout}>Cerrar Sesión</button>
                    </li>
                </ul>
            </div>
        </div>
    );
}
